import { render, staticRenderFns } from "./study-auth.vue?vue&type=template&id=5208644b&scoped=true&"
import script from "./study-auth.vue?vue&type=script&lang=ts&"
export * from "./study-auth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208644b",
  null
  
)

export default component.exports